import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import LayerActions from '../redux/layerRedux'
import { makeGetFilter } from '../selectors/filterSelector'
import Tooltip from 'rc-tooltip'
import '../assets/styles/rc-slider.css'
import Typography from '@material-ui/core/Typography'

const SliderTooltip = Slider.createSliderWithTooltip(Slider)

class SliderFilter extends PureComponent {
  static defaultProps = {
    layerName: '',
    min: 70,
    max: 100,
    value: 100,
    label: ' mol/m2'
  }

  handleChange = value => {
    const { actions, layerName, transformOut } = this.props

    actions.layerFilterUpdated(layerName, value)
  }

  render () {
    const { filter, min, max, label, title, transform = value => value, transformLabel } = this.props

    return (
      <Fragment>
        <div style={{ display: 'block', width: '100%' }} >
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography key='title'>{title}</Typography>
            <Typography key='value'>{`${transform(filter)}${transformLabel}`}</Typography>
          </div>
          <SliderTooltip
            key='slider'
            onChange={this.handleChange}
            value={filter}
            tipFormatter={value => `${transform(value)}${label}`}
            min={min}
            max={max}
            tipProps={{ style:{ zIndex: 9999, color: 'red' }}}
            />
          </div>
      </Fragment>
    )
  }
}

const makeMapStateToProps = () => {
  const getFilter = makeGetFilter()

  const mapStateToProps = (state, props) => {
    const filter = getFilter(state, props.layerName)
    return {
      filter: isNaN(filter) ? props.value : filter
    }
  }
  return mapStateToProps
}

const mapPropsToState = dispatch => {
  return {
    actions: {
      layerTransparencyUpdated: (layerName, layerOpacity, transparency) =>
        dispatch(
          LayerActions.layerTransparencyUpdated(
            layerName,
            layerOpacity,
            transparency
          )
        ),
      layerFilterUpdated: (layerName, filterFunction) =>
        dispatch(
          LayerActions.layerFilterUpdated(
            layerName,
            filterFunction
          )
        )
    }
  }
}

export default connect(makeMapStateToProps(), mapPropsToState)(
  SliderFilter
)



// WEBPACK FOOTER //
// ./src/components/SliderFilter.js